import { AppSettings } from '@/constants/app-settings';

// TODO move to shared
/**
 * Enhanced error tracking using PostHog's captureException
 * This provides better error grouping and integration with session replays
 */
export function captureError(
  error: Error,
  context?: {
    feature?: string;
    action?: string;
    [key: string]: any;
  },
) {
  if (typeof window !== 'undefined' && window.posthog) {
    window.posthog.captureException(error, {
      // Custom fingerprinting for better error grouping
      $exception_fingerprint: `${error.name}-${context?.feature || 'unknown'}`,
      context,
      app_version: AppSettings.version || 'unknown',
      environment: AppSettings.env || 'unknown',
    });
  }
}
